import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Input } from '../../components'
import { PasswordValidation } from '../../components/PasswordValidation/PasswordValidation'
import { TYP } from '../../components/TYP/TYP'
import { GlobalContext } from '../../contexts/Global'
import { encryptMail, getQueryParams, validatePassword } from '../../helpers'
import { ERROR_MESSAGES } from '../../helpers/errorMessages'
import { loginOnReact } from '../../helpers/loginOnReact'
import '../../index.css'
import * as S from './style'
import { eventDataLayer } from '../../commons/utils'

const Home = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [usernameError, setUsernameError] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const navigate = useNavigate()
  const queryParams = getQueryParams()

  const {
    state: { isAlternativeActive },
    dispatch,
  } = useContext(GlobalContext)

  useEffect(() => {
    if (queryParams.maggiortutela) {
      dispatch({ type: 'changeIsAlternativeActive', payload: true })
      const favicon = document.getElementById('favicon')
      favicon.href = '../../assets/images/favicon_alt.ico'
      document.getElementById('registrati-link').href =
        `${process.env.REACT_APP_REGISTRATION_URL}?maggiortutela=1`
    }
  }, [])

  const onContinueClickHandler = () => {
    setUsernameError(false)
    setPasswordError(false)
    document.querySelector('input#username').classList.remove('error')
    document.querySelector('input#password').classList.remove('error')
    document.querySelector('#Error span').innerHTML = ''
    let errorsCount = 0
    if (username.length === 0) {
      setUsernameError(ERROR_MESSAGES.required)
      errorsCount++
    }
    if (password.length === 0) {
      setPasswordError(ERROR_MESSAGES.required)
      errorsCount++
    }
    if (errorsCount > 0) {
      document.querySelector('#loader-scripts').classList.remove('visible')
      return
    }
    document.querySelector('#loader-scripts').classList.add('visible')
    eventDataLayer({
      event: 'start_process',
      stream: 'web',
      azione: 'login',
      metodo: 'mail',
      sezione: 'login',
    })
    loginOnReact(username, password, dispatch)
  }

  return (
    <S.HomeWrapper>
      <S.HomeHeaderWrapper isAlternativeActive={isAlternativeActive}>
        <S.HomeHeaderArea>
          <S.HomeHeaderTitle>
            <span>Benvenuto nell'Area Clienti.</span>
          </S.HomeHeaderTitle>
          <S.HomeHeaderSubtitle>
            <span>
              Qui puoi gestire in autonomia le tue forniture luce e gas,
              consultare le bollette e usufruire di tanti servizi comodamente
              online.
            </span>
          </S.HomeHeaderSubtitle>
        </S.HomeHeaderArea>
      </S.HomeHeaderWrapper>
      <S.HomeContentWrapper>
        <S.HomeContentForm>
          <div id="form-login">
            <S.HomeContentFormTitle>
              Inserisci i tuoi dati di accesso
            </S.HomeContentFormTitle>
            <S.HomeContentFormInputContainer>
              <Input
                id="username"
                label="E-mail o nome utente"
                placeholder="Inserisci e-mail o nome utente"
                helpMessage="Se hai effettuato la registrazione prima del 05/09/2016 puoi accedere all'Area Clienti usando il tuo Nome Utente"
                onChange={(e) => setUsername(e.target.value)}
                value={username}
                required
                errorMessage={usernameError}
                type="text"
              />
            </S.HomeContentFormInputContainer>
            <S.HomeContentFormInputCta>
              Hai dimenticato il{' '}
              <button
                className="anchor-link"
                onClick={() => {
                  dispatch({ type: 'changeForgotType', payload: 'username' })
                  eventDataLayer({
                    event: 'start_process',
                    stream: 'web',
                    azione: 'recupero_nome_utente',
                    sezione: 'login',
                  })
                  navigate(
                    `/reset-password?username=1${
                      queryParams.maggiortutela ? '&maggiortutela=1' : ''
                    }`
                  )
                }}
              >
                nome utente?
              </button>
            </S.HomeContentFormInputCta>
            <S.HomeContentFormInputContainer>
              <Input
                id="password"
                label="Password"
                type="password"
                placeholder="Inserisci la password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                required
                errorMessage={passwordError}
              />
            </S.HomeContentFormInputContainer>
            <S.HomeContentFormInputCta>
              Hai dimenticato la{' '}
              <button
                className="anchor-link"
                onClick={() => {
                  eventDataLayer({
                    event: 'start_process',
                    stream: 'web',
                    azione: 'recupero_password',
                    sezione: 'login',
                  })
                  dispatch({ type: 'changeForgotType', payload: 'password' })
                  navigate(
                    `/reset-password?password=1${
                      queryParams.maggiortutela ? '&maggiortutela=1' : ''
                    }`
                  )
                }}
              >
                password?
              </button>
            </S.HomeContentFormInputCta>
            <S.HomeContentErrorContainer id="Error">
              <span />
            </S.HomeContentErrorContainer>
            <S.HomeContentFormSubmitContainer>
              <S.ButtonsFocusContainer>
                <Button
                  aria-label="Accedi"
                  label="Accedi"
                  onClick={onContinueClickHandler}
                />
              </S.ButtonsFocusContainer>
            </S.HomeContentFormSubmitContainer>
          </div>
          <S.HomeContentForm id="form-login-otp" className="hidden">
            <S.HomeContentFormTitle>
              VERIFICA INDIRIZZO E-MAIL
            </S.HomeContentFormTitle>
            <S.HomeHeaderSubtitle>
              Solo per questa volta inserisci il codice di verifica che ti
              abbiamo inviato all’indirizzo{' '}
              {username ? encryptMail(username) : '****@xx.xx'} e accedi
              all’Area Clienti.
            </S.HomeHeaderSubtitle>
            <S.HomeContentFormInputContainer>
              <Input
                id="otp-input"
                label=""
                placeholder="Inserisci il codice"
                type="password"
                maxLength={6}
              />
            </S.HomeContentFormInputContainer>
            <S.HomeContentCta>
              <button className="anchor-link" id="resend-otp">
                Invia di nuovo
              </button>
            </S.HomeContentCta>
            <S.HomeContentFormSubmitContainer>
              <S.ButtonsFocusContainer>
                <Button aria-label="Accedi" label="Accedi" id="otp-btn" />
              </S.ButtonsFocusContainer>
            </S.HomeContentFormSubmitContainer>
            <S.HomeContentErrorContainer id="otp-error" secondStep>
              <span />
            </S.HomeContentErrorContainer>
          </S.HomeContentForm>
          <S.HomeContentForm id="form-login-password" className="hidden">
            <div className="reset-password-wrapper">
              <S.HomeContentFormTitle>
                La tua password è scaduta
              </S.HomeContentFormTitle>
              <S.HomeContentFormText>
                Per motivi di sicurezza è necessario aggiornare la password.
                <br />
                La tua e-mail/nome utente e la nuova password sono le
                credenziali che potrai usare per accedere sia all’app My A2A che
                all'Area Clienti del sito
              </S.HomeContentFormText>
              <S.HomeContentFormInputContainer>
                <Input
                  id="password-input"
                  label="Nuova Password"
                  placeholder="Inserisci password"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <PasswordValidation
                  value={newPassword}
                  style={{ marginBottom: '12px' }}
                />
                <Input
                  id="password-input-confirm"
                  label="Conferma Nuova Password"
                  placeholder="Conferma password"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                {confirmPassword && newPassword !== confirmPassword && (
                  <S.HomeContentErrorPwdContainer
                    className="visible"
                    secondStepPwd
                    id="new-password-error"
                  >
                    <span>
                      La password non coincide con quella precedentemente
                      inserita
                    </span>
                  </S.HomeContentErrorPwdContainer>
                )}
              </S.HomeContentFormInputContainer>
              <S.HomeContentErrorContainer secondStep id="password-error">
                <span />
              </S.HomeContentErrorContainer>
              <S.HomeContentFormSubmitContainer>
                <S.ButtonsFocusContainer>
                  <Button
                    label="Conferma"
                    id="password-btn"
                    className={
                      !validatePassword(newPassword) ||
                      newPassword !== confirmPassword
                        ? 'button-not-click'
                        : ''
                    }
                  />
                </S.ButtonsFocusContainer>
              </S.HomeContentFormSubmitContainer>
            </div>
            <div className="reset-password-typ hidden">
              <TYP title="Password modificata">
                Puoi utilizzare la nuova password per accedere all'app e
                all'Area Clienti. Per ripetere l'operazione dovrai attendere due
                ore dalla richiesta.
                <S.ButtonsFocusContainer>
                  <Button
                    aria-label="Accedi"
                    id="password-btn-accedi"
                    label="Accedi"
                  />
                </S.ButtonsFocusContainer>
              </TYP>
            </div>
          </S.HomeContentForm>
          <S.HomeContentFormSubmitContainer id="form-label">
            oppure
          </S.HomeContentFormSubmitContainer>
          <S.HomeContentFormBottomCtaContainer id="form-social-container">
            <S.ButtonsFocusContainer>
              <Button
                label="Continua con Google"
                isGoogle
                icon="Gmail"
                onClick={() => {
                  window.location.href = `${process.env.REACT_APP_GOOGLE_LOGIN}${
                    isAlternativeActive ? '&maggiortutela=1' : ''
                  }`
                  eventDataLayer({
                    event: 'start_process',
                    stream: 'web',
                    azione: 'login',
                    metodo: 'google',
                    sezione: 'login',
                  })
                }}
              />
            </S.ButtonsFocusContainer>
            <S.ButtonsFocusContainer>
              <Button
                label="Continua con Facebook"
                isFacebook
                icon="Facebook"
                onClick={() => {
                  window.location.href = `${
                    process.env.REACT_APP_FACEBOOK_LOGIN
                  }${isAlternativeActive ? '&maggiortutela=1' : ''}`
                  eventDataLayer({
                    event: 'start_process',
                    stream: 'web',
                    azione: 'login',
                    metodo: 'facebook',
                    sezione: 'login',
                  })
                }}
              />
            </S.ButtonsFocusContainer>
          </S.HomeContentFormBottomCtaContainer>
          <S.HomeContentFormBottomCtaContainer id="registrati-footer" anchor>
            <span>
              Non sei ancora registrato?{' '}
              <a
                id="registrati-link"
                href={process.env.REACT_APP_REGISTRATION_URL}
                onClick={() => {
                  eventDataLayer({
                    event: 'start_process',
                    stream: 'web',
                    azione: 'registrazione',
                    entry_point: 'login_page',
                    sezione: 'login',
                  })
                }}
              >
                Registrati
              </a>
            </span>
          </S.HomeContentFormBottomCtaContainer>
          <S.RecaptchaInfoContainer>
            <em>
              Questo sito è protetto da{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://developers.google.com/recaptcha/docs/v3?hl=it"
                data-tracked="true"
              >
                reCAPTCHA Invisibile (v. 3)
              </a>{' '}
              e su di esso si applicano{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://policies.google.com/privacy?hl=it"
                data-tracked="true"
              >
                l'Informativa sulla privacy
              </a>{' '}
              e i{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://policies.google.com/terms"
                data-tracked="true"
              >
                Termini del servizio
              </a>{' '}
              di Google.
            </em>
          </S.RecaptchaInfoContainer>
        </S.HomeContentForm>
      </S.HomeContentWrapper>
    </S.HomeWrapper>
  )
}

export default Home
